export const base_urls = {
    pharmaws: 'pharmaws/',
    dms: 'dms/',
    examws: 'examws/',
    f_auth: 'f-auth/',
    p_base: 'p-base/'
};
